<div class="">
  <a [routerLink]="['/dashboard/']" class="b-brand">
  <img src="assets/logo.png" alt="" height="40px">
  </a>
  <a href="javascript:" class="mobile-menu" [ngClass]="{ on: navCollapsed }" id="mobile-collapse" (click)="navCollapse()"><span></span></a>
</div>
